import React, { useEffect, useRef } from 'react';
import { Form, Formik, FormikValues } from 'formik';
import * as Yup from 'yup';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress
} from '@material-ui/core';
import { Alert } from '@material-ui/lab';

import FormikGrid from '../../../common/formik/FormikGrid';
import FormikButton from '../../../common/formik/FormikButton';
import FormikTextField from '../../../common/formik/FormikTextField';
import { Hazard } from '../Hazard.interface';
import { useUpdateHazard } from '../Hazard.hooks';

export interface HazardRenameDialogProps {
  open: boolean;
  hazard: Hazard;
  onCancel?: () => void;
  onChange?: (hasard: Partial<Hazard>) => void;
  onUpdate?: () => void;
}

const HazardRenameDialog: React.FC<HazardRenameDialogProps> = (
  props: HazardRenameDialogProps
) => {
  const { open, hazard, onCancel, onChange, onUpdate } = props;
  const formikRef = useRef<FormikValues>();
  const { updatedHazard, isUpdating, updateError, updateHazard } =
    useUpdateHazard(hazard.id);

  useEffect(() => {
    formikRef.current?.setSubmitting?.(isUpdating);
  }, [isUpdating]);

  useEffect(() => {
    if (updatedHazard) {
      onChange?.(updatedHazard);
      onUpdate?.();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedHazard]);

  return (
    <Dialog maxWidth='xs' open={open} onClose={onCancel}>
      {isUpdating && <LinearProgress />}
      <Formik
        innerRef={(formik: any) => (formikRef.current = formik)}
        initialValues={{ title: hazard.title } as Partial<Hazard>}
        validationSchema={Yup.object({
          title: Yup.string().required('Hazard title is required.')
        })}
        onSubmit={(dto: Partial<Hazard>) => {
          updateHazard(dto);
          onChange?.(dto);
        }}
      >
        <Form autoComplete='off'>
          <DialogTitle>Rename Hazard</DialogTitle>
          <DialogContent>
            <FormikGrid>
              <FormikTextField
                autoFocus
                type='text'
                name='title'
                label='Hazard Title'
                disabled={isUpdating}
              />
            </FormikGrid>
            {updateError && (
              <Alert severity='error'>{`Error occurred. ${updateError.message}`}</Alert>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancel}>Cancel</Button>
            <FormikButton>Rename</FormikButton>
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};

export default HazardRenameDialog;
